import { render } from "./ylycreatePromotion.vue?vue&type=template&id=82fafb2c&scoped=true"
import script from "./ylycreatePromotion.vue?vue&type=script&lang=js"
export * from "./ylycreatePromotion.vue?vue&type=script&lang=js"

import "./ylycreatePromotion.vue?vue&type=style&index=0&id=82fafb2c&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82fafb2c"]])

export default __exports__